export default "__VITE_ASSET__BtL6_9V4__"